import { useEffect, useState } from 'react';
import VoorstelCard from '../../../Components/VoorstelCard/VoorstelCard';
import './LeerkrachtGeschiedenisScreen.css';
import AxiosCaller from '../../../authenticatie/AxiosCaller';
import GetUserInfo from "../../authenticatie/GetUserInfo";

const LeerkrachtGeschiedenisScreen = () => {
    const { post } = AxiosCaller();
    const [history, setHistory] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchHistory();
    }, []);

    const fetchHistory = async () => {
        try {
            const currentUser = GetUserInfo();
           
        
            // Fetch voorstellen
            const response = await post('/voorstel/getVoorstellenByLeerkracht/' + currentUser._id);
           
            const voorstellenWithFlag = response.data.map(item => ({
                ...item,
                isKookGeschiedenis: true, // Marking as not from kookGeschiedenis
            }));
        
            // Fetch kookGeschiedenis
            const response2 = await post('/kookGeschiedenis/filtered', { leerkracht: currentUser.naam });
         
            const kookGeschiedenisWithFlag = response2.data.map(item => ({
                ...item,
                isKookGeschiedenis: true, // Marking as from kookGeschiedenis
            }));
         
            // Merge both arrays & sort by kookDatum (newest first)
            const combinedData = [...voorstellenWithFlag, ...kookGeschiedenisWithFlag].sort(
                (a, b) => new Date(b.kookDatum) - new Date(a.kookDatum)
            );
          
            setHistory(combinedData);
        
        } catch (error) {
            if (error.response?.status !== 409) {
                setError('Kan geen data halen van de database');
            }            
            console.error("Fetch error:", error);
        }
    };

    if (error) return <div>{error}</div>;

    return (
        <div className="Screen-container">
            <Geschiedenis data={history} updateList={fetchHistory} />
        </div>
    );
};

const Geschiedenis = ({ data, updateList }) => {
    const today = new Date();

    // Subtract 1 day to get yesterday
    today.setUTCDate(today.getUTCDate() - 1);

    const [maxHeight, setMaxHeight] = useState(0);
        
    useEffect(() => {
        const updateHeight = () => {
            setMaxHeight(0.7 * document.documentElement.clientHeight);
        };

        updateHeight(); // Initialiseren bij eerste render
        window.addEventListener("resize", updateHeight); // Updaten bij schermresizing

        return () => window.removeEventListener("resize", updateHeight); // Cleanup
    }, []);
    // Separate into upcoming and past
    const upcomingData = data.filter(entry => new Date(entry.kookDatum) >= today).sort((a, b) => new Date(a.kookDatum) - new Date(b.kookDatum));
    const pastData = data.filter(entry => new Date(entry.kookDatum) < today);

    return (
        <div>
            <h1 className="title">Geschiedenis</h1>


            {/* Past events */}
            {pastData.length > 0 && (
                <div style={{overflowY: "auto", maxHeight}}>
                    {pastData.map((event, index) => (
                        <VoorstelCard
                            key={index}
                            voorstel={event}
                            isKookGeschiedenis={event.isKookGeschiedenis} // Pass the flag
                            updateList={updateList}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default LeerkrachtGeschiedenisScreen;
